<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/t29Bp1/tc-custom/9781459226203.jpg?1704761334922" alt="This image is the cover for the book Married to a Stranger, Danger & Desire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Married to a Stranger, Danger & Desire
      </h1>
      <p class="bookDescription body article font2">
        <p>Sophia Langley's life is in turmoil. When she learns of her estranged fiancé's death in a shipwreck, the last thing she expects is for his twin brother, Callum Chatterton, to make a shock proposal!<br/><br/>Her inner romantic objects to a marriage of convenienceand brooding Cal makes it <i>very</i> clear that's all it can be. Yet to save her family Sophia accepts with trepidationand a highly inconvenient trembling of desire for her reluctant husband!<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Louise Allen
      </h2>
      
      <p class="authorDescription body article">Louise Allen has been immersing herself in history for as long as she can remember, finding landscapes and places evoke powerful images of the past. Venice, Burgundy &amp; the Greek islands are favourites. Louise lives on the Norfolk coast &amp; spends her spare time gardening, researching family history or travelling. Please visit Louise&#39;s website, www.louiseallenregency.com, her blog https://janeaustenslondon or find her on Twitter @LouiseRegency and on Facebook.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4f1e5bb3